import { useState } from '#app'
import { onMounted } from 'vue'

/**
 * 是否支持 hover（`(hover: hover)`）。SSR/水合首帧恒为 false，挂载后再检测，避免与 SSR 分支不一致。
 */
export function useHoverCapable() {
  const hoverCapable = useState('lip-hover-capable', () => false)
  const hoverCapabilityReady = useState('lip-hover-capable-ready', () => false)

  onMounted(() => {
    if (typeof window !== 'undefined' && window.matchMedia) {
      hoverCapable.value = window.matchMedia('(hover: hover)').matches
    }
    hoverCapabilityReady.value = true
  })

  return { hoverCapable, hoverCapabilityReady }
}
